import { BlockStack, Text, SkeletonBodyText, Box } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { AttendeeDetail, EventCategory } from "@features/events/types";
import { MultiSelectCombobox } from "@shared/ui";

interface TopicsOfInterestCardProps {
  selectedTopics: string[];
  categories: EventCategory[];
  onDataChange: (updates: Partial<AttendeeDetail>) => void;
  loading: boolean;
}

export default function TopicsOfInterestCard({
  selectedTopics,
  categories,
  onDataChange,
  loading,
}: TopicsOfInterestCardProps) {
  const { t } = useTranslation();

  const handleChange = (selectedValues: string[]) => {
    onDataChange({ topicsOfInterestIds: selectedValues });
  };

  if (loading) {
    return (
      <Box paddingBlockEnd={"200"}>
        <Text as="h1" variant="headingMd">
          {t("attendeeDetails.topicsOfInterest.title")}
        </Text>
        <br />
        <SkeletonBodyText lines={2} />
      </Box>
    );
  }

  const multiSelectOptions = categories.map((category) => ({
    label: category.name,
    value: category.id,
  }));

  return (
    <BlockStack gap="400">
      <Box paddingBlockEnd={"200"}>
        <Text as="h1" variant="headingMd">
          {t("attendeeDetails.topicsOfInterest.title")}
        </Text>
      </Box>

      <MultiSelectCombobox
        options={multiSelectOptions}
        selected={selectedTopics || []}
        onChange={handleChange}
        label={t("attendeeDetails.topicsOfInterest.searchLabel")}
        placeholder={t("attendeeDetails.topicsOfInterest.searchLabel")}
      />
    </BlockStack>
  );
}
